/**
 * @desc 到仓信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryToWarehouseRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryScattered/toWarehouse`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
